<template>
  <div class="header">
    <div class="headerContent">
      <div class="header_left">
        <img
          src="../assets/yunthee/yuntheeLogo.png"
          class="logo"
          @click="goIndex"
        />
      </div>

      <div class="phoneMenu" @click="openPhoneMenu">
        <img src="../assets/images/menu05.png" width="100%" height="100%" />
      </div>

      <div class="header_right">
        <div
          class="header_right_menu"
          v-for="(item, index) in menuList"
          :key="'main' + index"
        >
          <div
            class="header_right_menu_main"
            :class="item.select == true ? 'header_right_menu_mainSelect' : ''"
            @mouseenter="menuInChange(index)"
            @mouseleave="menuOutChange(index)"
            @click="menuClick(index, item.name)"
          >
            {{ item.name }}
            <img
              src="../assets/yunthee/dropIcon.png"
              width="11px"
              height="6px"
              style="margin: 0 0 2px 5px"
              v-if="item.drop"
            />
          </div>

          <div
            class="header_right_menu_sub"
            :style="[
              { height: item.subShow == true ? '269px' : '0px' },
              { width: item.subwidth },
            ]"
            @mouseenter="subMenuInChange(index)"
            @mouseleave="subMenuOutChange(index)"
            v-if="item.name != '关于芸希'"
          >
            <div
              class="header_right_menu_content"
              v-for="(subItem, subIndex) in item.subList"
              :key="'sub' + subIndex"
              @click="subMenuClick(item, subIndex, subItem.type, index)"
            >
              <!-- {{ subItem.name }} -->
              <div class="subItemBox">
                <div class="subTitle">
                  <div class="titleLeft">
                    <img
                      src="../assets/yunthee/titleIcon.png"
                      width="4px"
                      height="14px"
                      style="margin-right: 10px; margin-left: 10px"
                    />
                    {{ subItem.name }}
                  </div>
                  <div class="titleRight">
                    <img
                      src="../assets/yunthee/titleIcon02.png"
                      width="11px"
                      height="11px"
                      style="margin-right: 10px"
                    />
                  </div>
                </div>
                <div class="subBody">
                  <img :src="subItem.path" width="120px" height="auto" />
                </div>
                <div class="subBtn">
                  <span>查看更多></span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="header_right_menu_sub_spice"
            :style="[
              { height: item.subShow == true ? '80px' : '0px' },
              { width: item.subwidth },
              { right: 0 },
            ]"
            v-else
          >
            <div
              class="header_right_menu_content_spice"
              v-for="(subItem, subIndex) in item.subList"
              :key="'sub2' + subIndex"
              @click="subMenuClick(item, subIndex, subItem.type, index)"
              @mouseenter="subMenuInChangeSpace(index, subIndex)"
              @mouseleave="subMenuOutChangeSpace(index, subIndex)"
            >
              <div class="spoce_select_icon">
                <img
                  src="../assets/yunthee/titleIcon.png"
                  width="100%"
                  height="100%"
                  v-show="subItem.select"
                />
              </div>
              <span style="margin-left: 10px">{{ subItem.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <el-drawer
        :visible.sync="drawer"
        :with-header="false"
        title="菜单"
        :modal-append-to-body="false"
        size="60%"
      >
        <div class="phoneMenuMain">
          <ul>
            <li
              v-for="(item, index) in menuList"
              :key="item.name"
              @click="menuClick(index, item.name)"
            >
              <span>
                {{ item.name }}
              </span>
            </li>
          </ul>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<style scoped>
.phoneMenuMain {
  width: 100%;
  height: auto;
}
.phoneMenuMain ul {
  margin: 0;
  padding: 0;
}
.phoneMenuMain ul li {
  display: block;
  width: 100%;
  height: 80px;
  text-align: center;
  list-style: none;
  cursor: pointer;
  border-bottom: 1px solid #ebeef5;
}
.phoneMenuMain ul li span {
  line-height: 80px;
}
.phoneMenu {
  width: 30px;
  height: 30px;
  /*border-radius: 50%;*/
  /*background: linear-gradient(270deg,#2664fe 0%,#34e5f9 100%);*/

  overflow: hidden;
  position: relative;
  cursor: pointer;
  top: 17px;
  right: 25px;
  display: none;
  float: right;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  background: white;
}
.headerContent {
  width: 100%;
  height: 70px;
  background: white;
  margin: 0 auto;
  position: relative;
}

.header_left {
  float: left;
  width: 25%;
  height: 100px;
  overflow: hidden;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  left: 25px;
}
.logo {
  width: auto;
  height: 80px;
  object-fit: contain;
  cursor: pointer;
}
.header_right {
  float: left;
  width: 70%;
  height: 100px;
  margin-left: 50px;
  display: block;
}
.header_right_menu {
  float: left;
  /* position: relative; */
  width: 160px;
}
.header_right_menu_main {
  width: 160px;
  height: 65px;
  line-height: 100px;
  margin: 5px;
  padding: 0 10px;
  text-align: left;
  cursor: pointer;
  color: #000000;
}
.header_right_menu_main:hover {
  /* color: rgb(36, 104, 242);
  background-image: url('../assets/images/navtag3.png');
  background-repeat: no-repeat;
  background-position: bottom; */
  color: #447ef4;
}
.header_right_menu_mainSelect {
  /* color: rgb(36, 104, 242);
  background-image: url('../assets/images/navtag3.png');
  background-repeat: no-repeat;
  background-position: bottom; */
  color: #447ef4;
}
.header_right_menu_sub {
  position: absolute;
  left: 0;
  right: 0;
  top: 100px;
  margin-left: auto;
  margin-right: auto;
  background: rgb(255, 255, 255);
  overflow: hidden;
  transition: all 0.7s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header_right_menu_sub_spice {
  position: relative;
  right: 0;
  top: 25px;
  margin-left: auto;
  margin-right: auto;
  background: rgb(255, 255, 255);
  overflow: hidden;
  transition: all 0.7s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header_right_menu_content {
  width: 240px;
  height: 203px;
  line-height: 60px;
  padding: 0 10px;
  text-align: center;
  color: rgb(143, 148, 154);
  cursor: pointer;
}
.header_right_menu_content_spice {
  width: 113px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #6f7d8e;
}
.header_right_menu_content_spice .spoce_select_icon {
  width: 4px;
  height: 14px;
}
/* .header_right_menu_content:hover {
  background: rgb(76, 115, 191);
  color: rgb(255, 255, 255);
} */
.header_right_menu_content .subItemBox {
  width: 100%;
  height: 100%;
  background: #f6f7fb;
  border: 1px solid #e0e6ff;
  border-radius: 5px;
}
.header_right_menu_content .subItemBox .subTitle {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-content: center;
  background: #ffffff;
  border-radius: 5px 5px 0px 0px;
}
.header_right_menu_content .subItemBox .subTitle .titleLeft {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 550;
  text-align: left;
  color: #2468f2;
}
.header_right_menu_content .subItemBox .subTitle .titleRight {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header_right_menu_content .subItemBox .subBody {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header_right_menu_content .subItemBox .subBtn {
  width: 206px;
  height: 30px;
  background: #ffffff;
  border: 1px solid #2468f2;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: #2468f2;
  line-height: 39px;
}
@media screen and (max-width: 1200px) {
  .header_right {
    display: none;
  }
  .phoneMenu {
    display: block;
  }
}
</style>
<script>
import { getSolve, getServer } from '@/api/apiCenter'
export default {
  data() {
    return {
      menuList: [
        {
          name: '首页',
          url: '/home/index',
          subShow: false,
          select: true,
        },
        {
          name: '解决方案',
          subShow: false,
          select: false,
          url: '/solve/index',
        },
        {
          name: '产品服务',
          subShow: false,
          select: false,
          url: '/serve/index',
        },
        {
          name: '客户案例',
          subShow: false,
          select: false,
          url: '/case/index',
        },
        {
          name: '新闻资讯',
          subShow: false,
          select: false,
          url: '/yunNews/index',
        },
        {
          name: '关于芸希',
          subShow: false,
          select: false,
          url: '/joinus/advertise',
          subList: [
            {
              name: '公司简介',
              select: false,
              url: '/joinus/connet',
              type: 2,
            },
            {
              name: '加入我们',
              select: false,
              url: '/joinus/advertise',
              type: 2,
            },
          ],
        },
      ],
      clickMenuList: [
        '公司简介',
        '企业文化',
        '公司团队',
        '荣誉资质',
        '发展历程',
      ],
      drawer: false,
    }
  },
  mounted() {
    this.init()
    setTimeout(() => {
      this.initTabStyle()
    }, 300)
    this.$EventBus.$on('selectTab', (index) => {
      this.selectTab(index)
    })
    this.$EventBus.$on('setTitleStyle', () => {
      this.setTitleStyle()
    })
    setTimeout(() => {
      this.setTitleStyle()
    }, 100)
    this.$EventBus.$on('handleLogin', () => {
      this.handleLogin()
    })
    this.handleLogin()
  },
  beforeDestroy() {
    this.$EventBus.$off('selectTab')
    this.$EventBus.$off('setTitleStyle')
  },
  methods: {
    openPhoneMenu() {
      this.drawer = !this.drawer
    },
    goLogin() {
      this.$router.push('/pull/login')
      setTimeout(() => {
        this.$EventBus.$emit('setTitleStyle')
        this.$EventBus.$emit('setClass')
      }, 100)
    },
    openDel() {
      this.$EventBus.$emit('openDel')
    },
    setTitleStyle() {
      if (
        this.$route.fullPath == '/pull/login' ||
        this.$route.fullPath == '/pull/regiester'
      ) {
        let footer = document.getElementsByClassName('header')[0]
        console.log(1)
        footer.style.display = 'none'
      } else {
        let footer = document.getElementsByClassName('header')[0]
        footer.style.display = 'block'
      }
    },
    init() {
      let that = this
      getSolve().then((res) => {
        let solveList = res.data.data
        let solveSubList = []
        solveList.forEach((item) => {
          let data = {
            name: item.title,
            path: item.cover,
            url: '/solve/index',
            sid: item.id,
            select: false,
            type: 0,
          }
          solveSubList.push(data)
        })
        this.menuList[1].subList = solveSubList
        this.menuList[1].sid = solveList[0].id
        getServer().then((response) => {
          let productList = response.data.data
          let productSubList = []
          productList.forEach((element) => {
            let data = {
              name: element.title,
              path: element.cover,
              url: '/serve/index',
              sid: element.id,
              select: false,
              type: 1,
            }
            productSubList.push(data)
          })
          this.menuList[2].subList = productSubList
          this.menuList[2].sid = productList[0].id
          for (let i = 0; i < that.menuList.length; i++) {
            if (that.menuList[i].subList) {
              if (that.menuList[i].name == '关于芸希') {
                let width = that.menuList[i].subList.length * 113 + 'px'
                that.menuList[i].subwidth = width
              } else {
                let width = that.menuList[i].subList.length * 280 + 'px'
                that.menuList[i].subwidth = width
              }
              that.menuList[i].drop = true
            } else {
              that.menuList[i].drop = false
            }
          }

          console.log(this.menuList)
        })
      })
    },
    handleLogin() {
      let status = localStorage.getItem('loginStatus')
      let Phone = document.getElementsByClassName('connetPhone')[0]
      let loginBtn = document.getElementsByClassName('mianLogin')[0]
      console.log(status)
      if (status === '1') {
        loginBtn.style.display = 'none'
        Phone.style.right = '2%'
      }
    },
    initTabStyle() {
      //that.menuList[index].select=true;
      let index = sessionStorage.getItem('index') || 0
      for (let i = 0; i < this.menuList.length; i++) {
        this.menuList[i].select = false
      }
      this.menuList[index].select = true
    },
    //主菜单鼠标移入事件
    menuInChange(index) {
      let that = this
      if (that.menuList[index].subList != undefined) {
        that.menuList[index].subShow = true
      }
    },
    //主菜单鼠标移出事件
    menuOutChange(index) {
      let that = this
      that.menuList[index].subShow = false
    },
    //子菜单鼠标移入事件
    subMenuInChange(index) {
      let that = this
      that.menuList[index].subShow = true
    },
    //子菜单鼠标移出事件
    subMenuOutChange(index) {
      let that = this
      that.menuList[index].subShow = false
    },
    //特殊处理鼠标移入事件
    subMenuInChangeSpace(index, subindex) {
      let that = this
      that.menuList[index].subShow = true
      that.menuList[index].subList[subindex].select = true
    },
    //特殊处理鼠标移出事件
    subMenuOutChangeSpace(index, subindex) {
      let that = this
      that.menuList[index].subShow = false
      that.menuList[index].subList[subindex].select = false
    },
    //主菜单鼠标点击事件
    menuClick(index, name) {
      let that = this
      sessionStorage.index = index
      let clist = that.menuList[index]
      if (clist.sid != undefined) {
        that.$router.push({ path: clist.url, query: { sid: clist.sid } })
      } else {
        that.$router.push({ path: clist.url })
      }

      for (let i = 0; i < that.menuList.length; i++) {
        that.menuList[i].select = false
      }
      that.menuList[index].select = true

      if (name === '解决方案') {
        setTimeout(() => {
          this.$EventBus.$emit('routerQuerySolve')
        }, 100)
      }

      if (name === '产品服务') {
        setTimeout(() => {
          this.$EventBus.$emit('routerQueryServe')
        }, 100)
      }

      if (name === '加入我们') {
        setTimeout(() => {
          this.$EventBus.$emit('navJoinChange', name)
          this.$EventBus.$emit('initJoinStyle', index)
          this.$EventBus.$emit('goJoinTop')
        }, 100)
      }

      if (name === '客户案例') {
        setTimeout(() => {
          this.$EventBus.$emit('navCaseChange', name)
          this.$EventBus.$emit('initCaseStyle', index)
          this.$EventBus.$emit('goCaseTop')
        }, 100)
      }

      setTimeout(() => {
        this.$EventBus.$emit('setClass')
      }, 100)

      this.drawer = false
    },
    //子菜单鼠标点击事件
    subMenuClick(data, index, type, mIndex) {
      let that = this
      let clist = data.subList[index]
      sessionStorage.index = mIndex
      for (let i = 0; i < this.menuList.length; i++) {
        this.menuList[i].select = false
      }
      this.menuList[mIndex].select = true

      if (clist.sid != undefined) {
        that.$router.push({ path: clist.url, query: { sid: clist.sid } })
      } else {
        that.$router.push({ path: clist.url })
      }

      if (type === 0) {
        setTimeout(() => {
          this.$EventBus.$emit('routerQuerySolve')
        }, 100)
      }

      if (type === 1) {
        setTimeout(() => {
          this.$EventBus.$emit('routerQueryServe')
        }, 100)
      }
    },
    selectTab(index) {
      for (let i = 0; i < this.menuList.length; i++) {
        this.menuList[i].select = false
      }
      this.menuList[index].select = true
    },
    goIndex() {
      for (let i = 0; i < this.menuList.length; i++) {
        this.menuList[i].select = false
      }
      sessionStorage.index = 0
      this.menuList[0].select = true
      this.$router.push('/')
    },
  },
}
</script>
